const $ = require('jquery');
const form = require('aemps-form');

$(function () {
    form.showErrors(errors);
});	



// WEBPACK FOOTER //
// ./js/aemps/peticionRestablecer.js